import { render, staticRenderFns } from "./GroupAddGroupModalVerify.vue?vue&type=template&id=66073bdb"
import script from "./GroupAddGroupModalVerify.vue?vue&type=script&lang=js"
export * from "./GroupAddGroupModalVerify.vue?vue&type=script&lang=js"
import style0 from "./GroupAddGroupModalVerify.vue?vue&type=style&index=0&id=66073bdb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports